import { ReactNode } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

interface SiteLayoutProps {
  children: ReactNode;
}

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col">
      <SiteHeader />
      <main className="flex-1 pt-16">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}
